define('blocks/benefit/benefit',['require'],function (require) {
  (function(){
    var $slider = $('[data-carousel="benefit"]'),
        patternUserAgent = /iPhone|iPod|iPad|iOS|android/i,
        isMobile = !!(navigator.userAgent.match(patternUserAgent))
    ;

    function viewCarousel() {
      if (window.matchMedia('(min-width: 768px)').matches && window.matchMedia('(max-width: 1023px)').matches) {
        if (!$slider.is('.owl-loaded')) {
          $slider.owlCarousel({
            nav: false,
            dots: true,
            autoWidth:true,
            responsiveClass:true,
            items: 1,
            smartSpeed: 700,
          });
        }
      } else {
        if ($slider.is('.owl-loaded')) {
          $slider.trigger('destroy.owl.carousel');
        }
      }
    }

    viewCarousel();

    if (isMobile) {
      window.addEventListener('orientationchange', viewCarousel, false);
    } else {
      $(window).resize(viewCarousel);
    }

  })();
});

